module.exports = __webpack_public_path__ + "static/media/explorar-uerre-xs.22a125bc.jpg";